import React from 'react';
import Section from './Section';
import { Link } from 'react-router-dom';

const Eventos = () => {
  const eventos = [
    {
      slug: 'agro-capital',
      date: '01-05 JUN',
      type: 'FEIRA',
      title: 'INOVA AGRO - AGROCAPITAL 2026',
      time: '08:00 - 20:00',
      place: 'AGROCAPITAL, Goiânia',
    },
    {
      slug: 'cong-aviacao',
      date: '18-20 AGO',
      type: 'EVENTO',
      title: 'Congresso da Aviação Agrícola do Brasil',
      time: '10:00 - 18:00',
      place: 'Condomínio Aeronáutico Liberty (S.N.L.L), Goiânia',
    },
    {
      slug: 'agromkt-summit-2026',
      date: '04-05 SET',
      type: 'CONGRESSO',
      title: 'AgroMKT Summit 2026',
      time: 'Confira a programação',
      place: 'Teatro SESI, Goiânia',
    },
  ];

  return (
    <Section id="eventos" bgClass="bg-green-50" title="Próximos Eventos">
      <p className="max-w-3xl mx-auto text-center mb-8 text-gray-700">
        Participe dos nossos eventos e conecte-se com outros profissionais da área.
      </p>

      <div className="max-w-3xl mx-auto space-y-6">
        {eventos.map((e) => (
          <div
            key={e.slug}
            className="bg-white rounded-xl p-4 sm:p-6 flex flex-col md:flex-row items-start md:items-center justify-between shadow"
          >
            <div className="flex items-start sm:items-center w-full md:w-auto">
              <div className="bg-navy text-white w-14 h-14 sm:w-16 sm:h-16 flex flex-col items-center justify-center rounded mr-3 sm:mr-4 flex-shrink-0">
                <span className="font-bold text-base sm:text-lg">{e.date.split(' ')[0]}</span>
                <span className="text-xs uppercase">{e.date.split(' ')[1]}</span>
              </div>

              <div className="flex-1 min-w-0 flex flex-col gap-1">
                <div>
                  <span className="inline-flex items-center text-xs bg-gray-200 text-gray-700 px-2 py-0.5 rounded-full">
                    {e.type}
                  </span>
                </div>

                <h3 className="font-semibold text-navy text-sm sm:text-base md:text-lg mb-1 leading-tight">
                  {e.title}
                </h3>

                <div className="text-xs sm:text-sm text-gray-600 mt-1 flex flex-col sm:flex-row sm:space-x-4 space-y-1 sm:space-y-0">
                  <span className="flex items-center space-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-navy flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span className="truncate">{e.time}</span>
                  </span>

                  <span className="flex items-center space-x-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-navy flex-shrink-0"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M17.657 16.657L13.414 12.414a1 1 0 00-1.414 0L6.343 17.414A8 8 0 1117.657 16.657z"
                      />
                      <circle cx="12" cy="12" r="2" />
                    </svg>
                    <span className="truncate">{e.place}</span>
                  </span>
                </div>
              </div>
            </div>

            <Link
              to={`/eventos/${e.slug}`}
              className="bg-navy text-white py-2 px-4 rounded-full hover:bg-secondary mt-4 md:mt-0 w-full md:w-auto flex-shrink-0 text-center"
            >
              Detalhes
            </Link>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Eventos;